import SubscriptionMapper from '@web/mapper/SubscriptionMapper'
import client, { ApiVersion } from '@web/api/client'

export default class SubscriptionApi {
  static fetchAll (): Promise<RawSubscription[]> {
    const params = {
      expand: 'cancelPopupText'
    }
    return client.get('/payment-subscription', {
      params
    })
      .then(response => {
        return response.data.map(item => SubscriptionMapper.toClient(item))
      })
  }

  static fetch (id: number): Promise<RawSubscription> {
    const params = {
      expand: 'cancelPopupText'
    }
    return client.get(`/payment-subscriptions/${id}`, {
      params
    })
      .then(response => {
        return SubscriptionMapper.toClient(response.data)
      })
  }

  static cancel ({ id, reasonType, reason }: { id: number, reasonType?: string, reason?: string }): Promise<{ subscription: RawSubscription, redirectUrl?: string | null }> {
    return client.post(`/payment-subscriptions/cancel?id=${id}`, {
      reason_type: reasonType || '',
      reason: reason || ''
    })
      .then(response => {
        return {
          subscription: SubscriptionMapper.toClient(response.data.subscription),
          redirectUrl: response.data.redirectUrl
        }
      })
  }

  static applyDiscount (id: number): Promise<RawSubscription> {
    return client.post(`/payment-subscription/${id}/apply-discount`, {}, ApiVersion.v2)
      .then(response => {
        return SubscriptionMapper.toClient(response.data)
      })
  }

  static freeze (id: number): Promise<RawSubscription> {
    return client.post(`/payment-subscription/${id}/freeze`, {}, ApiVersion.v2)
      .then(response => {
        return SubscriptionMapper.toClient(response.data)
      })
  }

  static unfreeze (id: number): Promise<RawSubscription> {
    return client.post(`/payment-subscription/${id}/unfreeze?expand=cancelPopupText,advantages`, {}, ApiVersion.v2)
      .then(response => {
        return SubscriptionMapper.toClient(response.data.data)
      })
  }

  // ===== Оффбординг-воронка: ручки save-шагов =====

  /** Поставить подписку на паузу на выбранный интервал (шаг pause воронки). Использует freeze. */
  static pause (id: number, interval?: Interval): Promise<RawSubscription> {
    return client.post(`/payment-subscription/${id}/freeze`, interval ? { interval } : {}, ApiVersion.v2)
      .then(response => {
        return SubscriptionMapper.toClient(response.data.data ?? response.data)
      })
  }

  /** Продлить пробный период (шаг trial_extension воронки). days — из конфига шага. */
  static extendTrial (id: number, days: number): Promise<RawSubscription> {
    return client.post(`/payment-subscription/${id}/trial-extend`, { days }, ApiVersion.v2)
      .then(response => {
        return SubscriptionMapper.toClient(response.data.data ?? response.data)
      })
  }

  /** Применить скидку воронки (шаг discount). percent — из конфига активного шага. */
  static applyFunnelDiscount (id: number, percent: number): Promise<RawSubscription> {
    return client.post(`/payment-subscription/${id}/apply-funnel-discount`, { percent }, ApiVersion.v2)
      .then(response => {
        return SubscriptionMapper.toClient(response.data.data ?? response.data)
      })
  }

  /** Запрос на отмену с причинами опроса (шаг survey воронки). */
  static cancelRequest (id: number, reasons: string[], otherText?: string): void {
    client.post(`/payment-subscription/${id}/cancel-request`, {
      reasons,
      ...(otherText ? { other_text: otherText } : {})
    }, ApiVersion.v2)
  }
}
